var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/health-activities/get-user-health-activities.ts
import { SocketAsFetch } from "@leagueplatform/socket-as-fetch";
import { JOURNEY_EXPERIENCE_TEAM } from "@leagueplatform/health-journey-common";
var GET_USER_HEALTH_ACTIVITIES_MESSAGE_TYPE = "get_user_health_activities";
var getUserHealthActivities = ({
  date,
  activityStatuses,
  campaignId,
  // defaulting to version 2 to maintain backwards capability
  // new websocket version is version 3
  version = 2,
  errorContext
}) => SocketAsFetch.fetch(
  {
    message_type: GET_USER_HEALTH_ACTIVITIES_MESSAGE_TYPE,
    info: {
      version,
      date,
      activity_statuses: activityStatuses,
      user_health_campaign_id: campaignId
    }
  },
  {
    errorContext: __spreadValues({ ownershipTeam: JOURNEY_EXPERIENCE_TEAM }, errorContext)
  }
);

// src/health-activities/get-user-standalone-activities.ts
import { SocketAsFetch as SocketAsFetch2 } from "@leagueplatform/socket-as-fetch";
import { JOURNEY_EXPERIENCE_TEAM as JOURNEY_EXPERIENCE_TEAM2 } from "@leagueplatform/health-journey-common";
var GET_USER_STANDALONE_ACTIVITIES_MESSAGE_TYPE = "get_fotl_suggested_user_health_activities";
var getUserStandaloneActivities = (limit, errorContext) => SocketAsFetch2.fetch(
  {
    message_type: GET_USER_STANDALONE_ACTIVITIES_MESSAGE_TYPE,
    info: {
      limit
    }
  },
  {
    errorContext: __spreadValues({ ownershipTeam: JOURNEY_EXPERIENCE_TEAM2 }, errorContext)
  }
);

// src/health-activities/get-user-health-activity.ts
import { SocketAsFetch as SocketAsFetch3 } from "@leagueplatform/socket-as-fetch";
var GET_USER_HEALTH_ACTIVITY_MESSAGE_TYPE = "get_user_health_activity";
var getUserHealthActivity = (userActivityId, activityId, campaignId) => SocketAsFetch3.fetch({
  message_type: GET_USER_HEALTH_ACTIVITY_MESSAGE_TYPE,
  info: {
    id: userActivityId,
    activity_id: activityId,
    campaign_id: campaignId
  }
});

// src/health-activities/complete-user-health-activity.ts
import { SocketAsFetch as SocketAsFetch4 } from "@leagueplatform/socket-as-fetch";
var COMPLETE_USER_HEALTH_ACTIVITY_MESSAGE_TYPE = "complete_user_health_activity";
var completeUserHealthActivity = (userActivityId) => SocketAsFetch4.fetch({
  message_type: COMPLETE_USER_HEALTH_ACTIVITY_MESSAGE_TYPE,
  info: {
    user_health_activity_id: userActivityId
  }
});

// src/health-activities/dismiss-user-health-activity.ts
import { SocketAsFetch as SocketAsFetch5 } from "@leagueplatform/socket-as-fetch";
var DISMISS_USER_HEALTH_ACTIVITY_MESSAGE_TYPE = "dismiss_user_health_activity";
var dismissUserHealthActivity = (userActivityId) => SocketAsFetch5.fetch({
  message_type: DISMISS_USER_HEALTH_ACTIVITY_MESSAGE_TYPE,
  info: {
    user_health_activity_id: userActivityId
  }
});

// src/health-activities/set-activity-progress.ts
import { SocketAsFetch as SocketAsFetch6 } from "@leagueplatform/socket-as-fetch";
var SET_ACTIVITY_PROGRESS_MESSAGE_TYPE = "set_user_health_activity_verification_progress";
var setActivityProgress = (userActivityId, activityProgress) => SocketAsFetch6.fetch({
  message_type: SET_ACTIVITY_PROGRESS_MESSAGE_TYPE,
  info: {
    user_health_activity_id: userActivityId,
    activity_verification_progress: activityProgress
  }
});

// src/health-activities/constants/user-health-activity.constants.ts
var ACTIVITY_PROGRESS_PROPERTIES = /* @__PURE__ */ ((ACTIVITY_PROGRESS_PROPERTIES2) => {
  ACTIVITY_PROGRESS_PROPERTIES2["ACTIVITY_PROGRESS"] = "activity_verification_progress";
  ACTIVITY_PROGRESS_PROPERTIES2["COUNT_PROGRESS"] = "count_progress";
  ACTIVITY_PROGRESS_PROPERTIES2["HELPFUL_TIPS"] = "helpful_tips";
  return ACTIVITY_PROGRESS_PROPERTIES2;
})(ACTIVITY_PROGRESS_PROPERTIES || {});
var UserHealthActivitiesEndpoints = {
  userHealthActivities: "/v1/user-health-activities",
  questionComponentResponses: "/v1/question-component-responses",
  toolboxInteractionHub: "/v1/toolbox-interaction-hub",
  userHealthJourneyHistory: `/v2/user-health-journey-history`,
  userHealthActivity(userActivityId, campaignId, contentActivityId, userId) {
    if (campaignId && userActivityId && userId) {
      return `${this.userHealthActivities}?userId=${userId}&filter[activityId]=${userActivityId}&filter[campaignId]=${campaignId}`;
    }
    if (campaignId && contentActivityId) {
      return `${this.userHealthActivities}?filter[status]=active,completed&filter[campaignId]=${campaignId}&filter[activityId]=${contentActivityId}`;
    }
    return `${this.userHealthActivities}/${userActivityId}?include=user-health-campaign`;
  }
};

// src/health-activities/get-user-campaigns.ts
import { SocketAsFetch as SocketAsFetch7 } from "@leagueplatform/socket-as-fetch";
import { JOURNEY_EXPERIENCE_TEAM as JOURNEY_EXPERIENCE_TEAM3 } from "@leagueplatform/health-journey-common";
var GET_USER_CAMPAIGNS_MESSAGE_TYPE = "get_user_campaigns";
var getUserCampaigns = (campaignTypes, campaignStatuses, errorContext) => __async(void 0, null, function* () {
  return SocketAsFetch7.fetch(
    {
      message_type: GET_USER_CAMPAIGNS_MESSAGE_TYPE,
      info: {
        campaign_types: campaignTypes,
        // currently only used for challenge. Other options : [challenge|opt-in|suggested]
        campaign_statuses: campaignStatuses
      }
    },
    {
      errorContext: __spreadValues({ ownershipTeam: JOURNEY_EXPERIENCE_TEAM3 }, errorContext)
    }
  );
});

// src/health-activities/get-user-health-journey-history.ts
import { query, deserialise } from "kitsu-core";
import { leagueFetch } from "@leagueplatform/league-fetch";
var getUserHealthJourneyHistory = (..._0) => __async(void 0, [..._0], function* (params = {}) {
  const endpoint = UserHealthActivitiesEndpoints.userHealthJourneyHistory;
  const response = yield leagueFetch(`${endpoint}?${query(params)}`);
  const responseJson = yield response.json();
  const deserializedJson = deserialise(responseJson);
  if (!response.ok)
    return Promise.reject(deserializedJson);
  return Promise.resolve(deserializedJson);
});
var getUserHealthJourneyHistoryByPaginationLink = (page) => __async(void 0, null, function* () {
  const response = yield leagueFetch(page);
  const responseJson = yield response.json();
  const deserializedJson = deserialise(responseJson);
  if (!response.ok)
    return Promise.reject(deserializedJson);
  return Promise.resolve(deserializedJson);
});

// src/health-activities/get-user-health-activity-by-id.ts
import { leagueFetch as leagueFetch2 } from "@leagueplatform/league-fetch";
import { deserialise as deserialise2 } from "kitsu-core";

// src/health-activities/utils/handleCorruptActivity.ts
import { UserHealthActivityStatus } from "@leagueplatform/health-journey-common";
import { captureError } from "@leagueplatform/observability";
var errorTitle = "Corrupt Activity";
var errorMessages = {
  status: `Activity status must be one of ${Object.values(
    UserHealthActivityStatus
  ).join(", ")}`
};
var handleCorruptActivity = (activity) => {
  const activityDataObj = Array.isArray(activity) ? activity == null ? void 0 : activity[0] : activity;
  const {
    status,
    id: userActivityId,
    activityId,
    type: activityType,
    userHealthCampaign
  } = activityDataObj;
  const context = {
    tags: { ownershipTeam: "activities" },
    context: {
      activity: {
        userActivityId,
        activityId,
        activityType,
        userHealthCampaign: userHealthCampaign == null ? void 0 : userHealthCampaign.data
      }
    }
  };
  let error = null;
  if (!status) {
    error = new Error(errorMessages.status);
  }
  if (error) {
    error.name = errorTitle;
    captureError(error, context);
    throw error;
  }
};

// src/health-activities/get-user-health-activity-by-id.ts
var getUserHealthActivityById = (userHealthActivityId, campaignId, contentActivityId, userId) => __async(void 0, null, function* () {
  const endpoint = UserHealthActivitiesEndpoints.userHealthActivity(
    userHealthActivityId,
    campaignId,
    contentActivityId,
    userId
  );
  const response = yield leagueFetch2(endpoint);
  const responseJson = yield response.json();
  const deserializedJson = deserialise2(responseJson);
  if (!response.ok)
    return Promise.reject(deserializedJson);
  handleCorruptActivity(deserializedJson.data);
  return Promise.resolve(deserializedJson);
});

// src/health-activities/post-toolbox-interaction-hub.ts
import { leagueFetch as leagueFetch3 } from "@leagueplatform/league-fetch";

// src/health-activities/types/post-question-component.types.ts
var TOOLBOX_INTERACTION_HUB_DATA_TYPE = "toolbox-interaction-hub-request";

// src/health-activities/post-toolbox-interaction-hub.ts
var postToolboxInteractionHub = (_0) => __async(void 0, [_0], function* ({
  userActivityId,
  userHealthCampaignId,
  components = [],
  skippedComponents,
  completedActivity = false
}) {
  const response = yield leagueFetch3(
    UserHealthActivitiesEndpoints.toolboxInteractionHub,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/vnd.api+json"
      },
      body: JSON.stringify({
        data: {
          id: userActivityId,
          type: TOOLBOX_INTERACTION_HUB_DATA_TYPE,
          attributes: {
            userHealthCampaignId,
            completedActivity,
            skippedComponents,
            components
          }
        }
      })
    }
  );
  if (response.ok) {
    try {
      return yield response.json();
    } catch (e) {
      return null;
    }
  }
  throw new Error("Something went wrong while fetching!");
});

// src/health-activities/types/health-activity-component-enums.types.ts
var BannerTypes = /* @__PURE__ */ ((BannerTypes2) => {
  BannerTypes2["subtle"] = "subtle";
  BannerTypes2["primary"] = "primary";
  BannerTypes2["secondary"] = "secondary";
  return BannerTypes2;
})(BannerTypes || {});
var StringInputMethodType = /* @__PURE__ */ ((StringInputMethodType2) => {
  StringInputMethodType2["line"] = "line";
  StringInputMethodType2["box"] = "box";
  return StringInputMethodType2;
})(StringInputMethodType || {});
var DateInputMethodType = /* @__PURE__ */ ((DateInputMethodType2) => {
  DateInputMethodType2["datePick"] = "date-pick";
  DateInputMethodType2["monthYear"] = "month-year";
  return DateInputMethodType2;
})(DateInputMethodType || {});
var AdditionalDateOptionUnit = /* @__PURE__ */ ((AdditionalDateOptionUnit2) => {
  AdditionalDateOptionUnit2["day"] = "day";
  AdditionalDateOptionUnit2["month"] = "month";
  AdditionalDateOptionUnit2["year"] = "year";
  AdditionalDateOptionUnit2["week"] = "week";
  AdditionalDateOptionUnit2["noAnswer"] = "no-answer";
  return AdditionalDateOptionUnit2;
})(AdditionalDateOptionUnit || {});
var StyleHorizontalAlignmentType = /* @__PURE__ */ ((StyleHorizontalAlignmentType2) => {
  StyleHorizontalAlignmentType2["start"] = "start";
  StyleHorizontalAlignmentType2["center"] = "center";
  StyleHorizontalAlignmentType2["end"] = "end";
  return StyleHorizontalAlignmentType2;
})(StyleHorizontalAlignmentType || {});
var StyleBorderRadiusType = /* @__PURE__ */ ((StyleBorderRadiusType2) => {
  StyleBorderRadiusType2["pill"] = "pill";
  StyleBorderRadiusType2["medium"] = "medium";
  return StyleBorderRadiusType2;
})(StyleBorderRadiusType || {});
var StyleBackgroundColorType = /* @__PURE__ */ ((StyleBackgroundColorType2) => {
  StyleBackgroundColorType2["decorativeBrandPrimaryPastel"] = "decorative-brand-primary-pastel";
  StyleBackgroundColorType2["decorativeBrandSecondaryPastel"] = "decorative-brand-secondary-pastel";
  StyleBackgroundColorType2["decorativeBrandTertiaryPastel"] = "decorative-brand-tertiary-pastel";
  return StyleBackgroundColorType2;
})(StyleBackgroundColorType || {});
var ProgressTrackingInputMethod = /* @__PURE__ */ ((ProgressTrackingInputMethod2) => {
  ProgressTrackingInputMethod2["button"] = "button";
  ProgressTrackingInputMethod2["horizontalBar"] = "horizontal-bar";
  ProgressTrackingInputMethod2["circularBar"] = "circular-bar";
  return ProgressTrackingInputMethod2;
})(ProgressTrackingInputMethod || {});
var BiometricStatusType = /* @__PURE__ */ ((BiometricStatusType2) => {
  BiometricStatusType2["inRange"] = "in-range";
  BiometricStatusType2["outOfRange"] = "out-of-range";
  BiometricStatusType2["inconclusive"] = "inconclusive";
  BiometricStatusType2["noDataAvailable"] = "no-data-available";
  return BiometricStatusType2;
})(BiometricStatusType || {});
var FreeTextInputType = /* @__PURE__ */ ((FreeTextInputType2) => {
  FreeTextInputType2["string"] = "string";
  FreeTextInputType2["integer"] = "integer";
  return FreeTextInputType2;
})(FreeTextInputType || {});
var WeightUnits = /* @__PURE__ */ ((WeightUnits2) => {
  WeightUnits2["pounds"] = "lbs";
  WeightUnits2["kilogram"] = "kg";
  return WeightUnits2;
})(WeightUnits || {});
var HeightUnits = /* @__PURE__ */ ((HeightUnits2) => {
  HeightUnits2["inches"] = "inches";
  HeightUnits2["centimeter"] = "cm";
  return HeightUnits2;
})(HeightUnits || {});
var DateTimeInputDisplay = /* @__PURE__ */ ((DateTimeInputDisplay2) => {
  DateTimeInputDisplay2["full"] = "full";
  DateTimeInputDisplay2["dateOnly"] = "date-only";
  DateTimeInputDisplay2["timeOnly"] = "time-only";
  return DateTimeInputDisplay2;
})(DateTimeInputDisplay || {});

// src/challenges/get-challenge-data-by-id.ts
import { deserialise as deserialise3 } from "kitsu-core";
import { leagueFetch as leagueFetch4 } from "@leagueplatform/league-fetch";
import { JOURNEY_EXPERIENCE_TEAM as JOURNEY_EXPERIENCE_TEAM4 } from "@leagueplatform/health-journey-common";

// src/challenges/constants/challenge-requests.constants.ts
var CHALLENGES_PATH = "v2/challenges";
var USER_CHALLENGE_PATH = "v1/user-challenges";
var CHALLENGE_PRIVACY_PATH = "v1/challenge-config";
var CHALLENGE_HIGHLIGHTS_PATH = "v1/challenge-feed-items";
var USER_CHALLENGES_RANKINGS_PATH = "v2/user-challenges-rankings?include=user";
var AVATARS_PATH = "v1/avatars?filter[type]=";
var CHALLENGE_HIGHLIGHT_FEED_TYPES = /* @__PURE__ */ ((CHALLENGE_HIGHLIGHT_FEED_TYPES3) => {
  CHALLENGE_HIGHLIGHT_FEED_TYPES3["CHALLENGE"] = "challenge";
  CHALLENGE_HIGHLIGHT_FEED_TYPES3["TEAM"] = "team";
  return CHALLENGE_HIGHLIGHT_FEED_TYPES3;
})(CHALLENGE_HIGHLIGHT_FEED_TYPES || {});
var getHighlightFeedByIdPath = (feedType, challengeId) => {
  const baseHighlightsPath = `${CHALLENGE_HIGHLIGHTS_PATH}?include=challenge,challenge-feed-item-reaction&filter`;
  if (feedType === "team" /* TEAM */) {
    return `${baseHighlightsPath}[${"challenge" /* CHALLENGE */}]=${challengeId}&filter[${"team" /* TEAM */}]=`;
  }
  return `${baseHighlightsPath}[${feedType}]=`;
};
var HIGHLIGHT_REACTIONS_PATH = "v1/challenge-feed-item-reactions";
var TEAMS_PATH = "v1/challenge-teams";
var TEAM_CHALLENGE_RANKS_PATH = "v2/team-challenges-rankings?filter[challenge]=";
var CHALLENGE_TYPES = /* @__PURE__ */ ((CHALLENGE_TYPES3) => {
  CHALLENGE_TYPES3["USER"] = "user";
  CHALLENGE_TYPES3["TEAM"] = "team";
  return CHALLENGE_TYPES3;
})(CHALLENGE_TYPES || {});
var CHALLENGE_DATA_TYPES = /* @__PURE__ */ ((CHALLENGE_DATA_TYPES2) => {
  CHALLENGE_DATA_TYPES2["CHALLENGE"] = "challenge";
  CHALLENGE_DATA_TYPES2["USER"] = "user";
  CHALLENGE_DATA_TYPES2["USER_CHALLENGE"] = "user-challenge";
  CHALLENGE_DATA_TYPES2["USER_CHALLENGE_RANK"] = "user-challenge-rank";
  CHALLENGE_DATA_TYPES2["CHALLENGE_TEAM"] = "challenge-team";
  CHALLENGE_DATA_TYPES2["CHALLENGE_TEAM_RANK"] = "team-challenge-rank";
  CHALLENGE_DATA_TYPES2["CHALLENGE_CONFIG"] = "challenge-config";
  CHALLENGE_DATA_TYPES2["CHALLENGE_FEED_ITEM"] = "challenge-feed-item";
  CHALLENGE_DATA_TYPES2["CHALLENGE_FEED_ITEM_REACTION"] = "challenge-feed-item-reaction";
  return CHALLENGE_DATA_TYPES2;
})(CHALLENGE_DATA_TYPES || {});
var CHALLENGE_HIGHLIGHT_IMAGE_TYPES = /* @__PURE__ */ ((CHALLENGE_HIGHLIGHT_IMAGE_TYPES2) => {
  CHALLENGE_HIGHLIGHT_IMAGE_TYPES2["USER"] = "user-profile";
  CHALLENGE_HIGHLIGHT_IMAGE_TYPES2["TEAM"] = "team-profile";
  CHALLENGE_HIGHLIGHT_IMAGE_TYPES2["HIGHLIGHT"] = "header-image";
  return CHALLENGE_HIGHLIGHT_IMAGE_TYPES2;
})(CHALLENGE_HIGHLIGHT_IMAGE_TYPES || {});
var CHALLENGE_HIGHLIGHT_REACTION_TYPES = /* @__PURE__ */ ((CHALLENGE_HIGHLIGHT_REACTION_TYPES2) => {
  CHALLENGE_HIGHLIGHT_REACTION_TYPES2["LIKE"] = "like";
  CHALLENGE_HIGHLIGHT_REACTION_TYPES2["UNLIKE"] = "unlike";
  CHALLENGE_HIGHLIGHT_REACTION_TYPES2["VIEW_LIKES"] = "view likes";
  return CHALLENGE_HIGHLIGHT_REACTION_TYPES2;
})(CHALLENGE_HIGHLIGHT_REACTION_TYPES || {});
var CHALLENGE_PATCH_OPERATIONS = /* @__PURE__ */ ((CHALLENGE_PATCH_OPERATIONS4) => {
  CHALLENGE_PATCH_OPERATIONS4["ADD"] = "add";
  CHALLENGE_PATCH_OPERATIONS4["REMOVE"] = "remove";
  return CHALLENGE_PATCH_OPERATIONS4;
})(CHALLENGE_PATCH_OPERATIONS || {});
var CHALLENGE_HIGHLIGHT_EVENT_TYPES = /* @__PURE__ */ ((CHALLENGE_HIGHLIGHT_EVENT_TYPES2) => {
  CHALLENGE_HIGHLIGHT_EVENT_TYPES2["CHALLENGE"] = "challenge";
  CHALLENGE_HIGHLIGHT_EVENT_TYPES2["TEAM"] = "team";
  CHALLENGE_HIGHLIGHT_EVENT_TYPES2["ACHIEVEMENT"] = "achievement";
  CHALLENGE_HIGHLIGHT_EVENT_TYPES2["STEPS"] = "step";
  CHALLENGE_HIGHLIGHT_EVENT_TYPES2["MINUTES"] = "minute";
  CHALLENGE_HIGHLIGHT_EVENT_TYPES2["COMPLETED_ACTIVITY"] = "activityCompleted";
  CHALLENGE_HIGHLIGHT_EVENT_TYPES2["MINDFUL_MINUTE"] = "mindfulMinute";
  return CHALLENGE_HIGHLIGHT_EVENT_TYPES2;
})(CHALLENGE_HIGHLIGHT_EVENT_TYPES || {});
var LEADERBOARD_RANKING_UNIT = /* @__PURE__ */ ((LEADERBOARD_RANKING_UNIT2) => {
  LEADERBOARD_RANKING_UNIT2["STEPS"] = "steps";
  LEADERBOARD_RANKING_UNIT2["MINUTES"] = "minutes";
  LEADERBOARD_RANKING_UNIT2["ACTIVITIES"] = "activities";
  LEADERBOARD_RANKING_UNIT2["TOKENS"] = "tokens";
  return LEADERBOARD_RANKING_UNIT2;
})(LEADERBOARD_RANKING_UNIT || {});

// src/challenges/get-challenge-data-by-id.ts
var { USER_CHALLENGE, CHALLENGE_TEAM } = CHALLENGE_DATA_TYPES;
var getChallengeDataById = (challengeId, errorContext) => __async(void 0, null, function* () {
  const response = yield leagueFetch4(
    `${CHALLENGES_PATH}/${challengeId}?include=${USER_CHALLENGE},${CHALLENGE_TEAM}`,
    {
      errorContext: __spreadValues({ ownershipTeam: JOURNEY_EXPERIENCE_TEAM4 }, errorContext)
    }
  );
  if (!response.ok) {
    throw new Error(`getChallengeDataById error: ${response.status}`);
  }
  const responseJson = yield response.json();
  return deserialise3(responseJson);
});

// src/challenges/get-all-challenges.ts
import { leagueFetch as leagueFetch5 } from "@leagueplatform/league-fetch";
import { JOURNEY_EXPERIENCE_TEAM as JOURNEY_EXPERIENCE_TEAM5 } from "@leagueplatform/health-journey-common";
import { deserialise as deserialise4 } from "kitsu-core";
var getAllChallenges = (challengeType, errorContext) => __async(void 0, null, function* () {
  const allChallengesRequestPath = challengeType ? `${CHALLENGES_PATH}?filter[challengeType]=${challengeType}` : CHALLENGES_PATH;
  const response = yield leagueFetch5(allChallengesRequestPath, {
    errorContext: __spreadValues({ ownershipTeam: JOURNEY_EXPERIENCE_TEAM5 }, errorContext)
  });
  if (!response.ok) {
    throw new Error(`getAllChallenges error: ${response.status}`);
  }
  const responseJson = yield response.json();
  return deserialise4(responseJson);
});

// src/challenges/get-challenge-config.ts
import { leagueFetch as leagueFetch6 } from "@leagueplatform/league-fetch";
import { JOURNEY_EXPERIENCE_TEAM as JOURNEY_EXPERIENCE_TEAM6 } from "@leagueplatform/health-journey-common";
import { deserialise as deserialise5 } from "kitsu-core";
var getChallengeConfig = (userChallengeId, errorContext) => __async(void 0, null, function* () {
  if (!userChallengeId) {
    return null;
  }
  const response = yield leagueFetch6(
    `${CHALLENGE_PRIVACY_PATH}/${userChallengeId}`,
    {
      errorContext: __spreadValues({ ownershipTeam: JOURNEY_EXPERIENCE_TEAM6 }, errorContext)
    }
  );
  if (!response.ok) {
    throw new Error(`getChallengeConfig error: ${response.status}`);
  }
  const responseJson = yield response.json();
  return deserialise5(responseJson);
});

// src/challenges/post-user-challenge.ts
import { leagueFetch as leagueFetch7 } from "@leagueplatform/league-fetch";
import { JOURNEY_EXPERIENCE_TEAM as JOURNEY_EXPERIENCE_TEAM7 } from "@leagueplatform/health-journey-common";
var postUserChallenge = (challengeTrackingMode, challengeId, errorContext) => __async(void 0, null, function* () {
  const response = yield leagueFetch7(USER_CHALLENGE_PATH, {
    method: "POST",
    headers: {
      "Content-Type": "application/vnd.api+json"
    },
    body: JSON.stringify({
      data: {
        type: "user-challenge" /* USER_CHALLENGE */,
        attributes: {
          enrollmentStatus: "enrolled",
          termsAndConditionsAccepted: true,
          challengeMode: challengeTrackingMode
        },
        relationships: {
          challenge: {
            data: {
              id: challengeId,
              type: "challenge" /* CHALLENGE */
            }
          }
        }
      }
    }),
    errorContext: __spreadValues({ ownershipTeam: JOURNEY_EXPERIENCE_TEAM7 }, errorContext)
  });
  if (response.ok) {
    return response.json();
  }
  throw new Error("Something went wrong while fetching!");
});

// src/challenges/delete-user-challenge.ts
import { leagueFetch as leagueFetch8 } from "@leagueplatform/league-fetch";
import { JOURNEY_EXPERIENCE_TEAM as JOURNEY_EXPERIENCE_TEAM8 } from "@leagueplatform/health-journey-common";
var deleteUserChallenge = (userChallengeId, errorContext) => __async(void 0, null, function* () {
  const response = yield leagueFetch8(
    `${USER_CHALLENGE_PATH}/${userChallengeId}`,
    {
      method: "DELETE",
      errorContext: __spreadValues({ ownershipTeam: JOURNEY_EXPERIENCE_TEAM8 }, errorContext)
    }
  );
  if (response.ok) {
    return;
  }
  throw new Error("Something went wrong while deleting!");
});

// src/challenges/patch-highlight-reaction.ts
import { leagueFetch as leagueFetch9 } from "@leagueplatform/league-fetch";
import { JOURNEY_EXPERIENCE_TEAM as JOURNEY_EXPERIENCE_TEAM9 } from "@leagueplatform/health-journey-common";
var patchHighlightReaction = (reactionId, operationType, errorContext) => __async(void 0, null, function* () {
  const response = yield leagueFetch9(
    `${HIGHLIGHT_REACTIONS_PATH}/${reactionId}`,
    {
      method: "PATCH",
      body: JSON.stringify({
        data: {
          id: reactionId,
          type: "challenge-feed-item-reaction" /* CHALLENGE_FEED_ITEM_REACTION */,
          attributes: {
            reactionType: "like" /* LIKE */,
            // Can be other emotions in future
            operationType
          }
        }
      }),
      errorContext: __spreadValues({ ownershipTeam: JOURNEY_EXPERIENCE_TEAM9 }, errorContext)
    }
  );
  if (response.ok) {
    return response.json();
  }
  throw new Error("Something went wrong while patching!");
});

// src/challenges/patch-privacy-config.ts
import { leagueFetch as leagueFetch10 } from "@leagueplatform/league-fetch";
import { JOURNEY_EXPERIENCE_TEAM as JOURNEY_EXPERIENCE_TEAM10 } from "@leagueplatform/health-journey-common";
var patchChallengesPrivacySetting = (userChallengeId, showFeedItems, errorContext) => __async(void 0, null, function* () {
  const response = yield leagueFetch10(
    `${CHALLENGE_PRIVACY_PATH}/${userChallengeId}`,
    {
      method: "PATCH",
      body: JSON.stringify({
        data: {
          attributes: {
            showFeedItems
          },
          id: userChallengeId,
          type: "challenge-config" /* CHALLENGE_CONFIG */
        }
      }),
      errorContext: __spreadValues({ ownershipTeam: JOURNEY_EXPERIENCE_TEAM10 }, errorContext)
    }
  );
  if (response.ok) {
    return response.json();
  }
  throw new Error("Something went wrong while patching!");
});

// src/challenges/patch-challenge-team.ts
import { leagueFetch as leagueFetch11 } from "@leagueplatform/league-fetch";
import { JOURNEY_EXPERIENCE_TEAM as JOURNEY_EXPERIENCE_TEAM11 } from "@leagueplatform/health-journey-common";
var patchChallengeTeam = (challengeTeamId, challengeId, operationType, errorContext) => __async(void 0, null, function* () {
  const response = yield leagueFetch11(`${TEAMS_PATH}/${challengeTeamId}`, {
    method: "PATCH",
    body: JSON.stringify({
      data: {
        id: challengeTeamId,
        type: "challenge-team" /* CHALLENGE_TEAM */,
        attributes: {
          operationType
        },
        relationships: {
          challenge: {
            data: {
              id: challengeId,
              type: "challenge" /* CHALLENGE */
            }
          }
        }
      }
    }),
    errorContext: __spreadValues({ ownershipTeam: JOURNEY_EXPERIENCE_TEAM11 }, errorContext)
  });
  if (response.ok) {
    return response.json();
  }
  throw new Error("Something went wrong while patching!");
});

// src/challenges/get-user-challenge-ranks.ts
import { deserialise as deserialise6 } from "kitsu-core";
import { JOURNEY_EXPERIENCE_TEAM as JOURNEY_EXPERIENCE_TEAM12 } from "@leagueplatform/health-journey-common";
import { leagueFetch as leagueFetch12 } from "@leagueplatform/league-fetch";
var getUserChallengeRanks = (challengeId, requestPath, teamId, errorContext) => __async(void 0, null, function* () {
  const baseFetchPath = requestPath || `${USER_CHALLENGES_RANKINGS_PATH}&page[size]=10&challengeId=${challengeId}`;
  const userChallengeRanksPath = (teamId == null ? void 0 : teamId.length) ? `${baseFetchPath}&filter[team]=${teamId}` : baseFetchPath;
  const response = yield leagueFetch12(userChallengeRanksPath, {
    errorContext: __spreadValues({ ownershipTeam: JOURNEY_EXPERIENCE_TEAM12 }, errorContext)
  });
  if (!response.ok) {
    throw new Error(`getUserChallengeRanks error: ${response.status}`);
  }
  const responseJson = yield response.json();
  return deserialise6(responseJson);
});

// src/challenges/get-individual-user-rank.ts
import { deserialise as deserialise7 } from "kitsu-core";
import { JOURNEY_EXPERIENCE_TEAM as JOURNEY_EXPERIENCE_TEAM13 } from "@leagueplatform/health-journey-common";
import { leagueFetch as leagueFetch13 } from "@leagueplatform/league-fetch";
var getIndividualUserRank = (challengeId, userId, errorContext) => __async(void 0, null, function* () {
  const response = yield leagueFetch13(
    `${USER_CHALLENGES_RANKINGS_PATH}&filter[user]=${userId}&challengeId=${challengeId}`,
    {
      errorContext: __spreadValues({ ownershipTeam: JOURNEY_EXPERIENCE_TEAM13 }, errorContext)
    }
  );
  if (!response.ok) {
    throw new Error(`getIndividualUserRank error: ${response.status}`);
  }
  const responseJson = yield response.json();
  return deserialise7(responseJson);
});

// src/challenges/get-avatars.ts
import { leagueFetch as leagueFetch14 } from "@leagueplatform/league-fetch";
import { JOURNEY_EXPERIENCE_TEAM as JOURNEY_EXPERIENCE_TEAM14 } from "@leagueplatform/health-journey-common";
import { deserialise as deserialise8 } from "kitsu-core";
var getAvatars = (avatarType, errorContext) => __async(void 0, null, function* () {
  const response = yield leagueFetch14(`${AVATARS_PATH}${avatarType}`, {
    errorContext: __spreadValues({ ownershipTeam: JOURNEY_EXPERIENCE_TEAM14 }, errorContext)
  });
  if (!response.ok) {
    throw new Error(`getAvatars error: ${response.status}`);
  }
  const responseJson = yield response.json();
  return deserialise8(responseJson);
});

// src/challenges/get-highlights-feed-by-id.ts
import { leagueFetch as leagueFetch15 } from "@leagueplatform/league-fetch";
import { JOURNEY_EXPERIENCE_TEAM as JOURNEY_EXPERIENCE_TEAM15 } from "@leagueplatform/health-journey-common";
import { deserialise as deserialise9 } from "kitsu-core";
var getHighlightsFeedById = (feedType, id, challengeId, requestPath, errorContext) => __async(void 0, null, function* () {
  const fetchHighlightsByIdPath = requestPath || `${getHighlightFeedByIdPath(feedType, challengeId)}${id}&page[size]=10`;
  const response = yield leagueFetch15(fetchHighlightsByIdPath, {
    errorContext: __spreadValues({ ownershipTeam: JOURNEY_EXPERIENCE_TEAM15 }, errorContext)
  });
  if (!response.ok) {
    throw new Error(`getHighlightsFeedById error: ${response.status}`);
  }
  const responseJson = yield response.json();
  return deserialise9(responseJson);
});

// src/challenges/get-all-teams.ts
import { leagueFetch as leagueFetch16 } from "@leagueplatform/league-fetch";
import { JOURNEY_EXPERIENCE_TEAM as JOURNEY_EXPERIENCE_TEAM16 } from "@leagueplatform/health-journey-common";
import { deserialise as deserialise10 } from "kitsu-core";
var { CHALLENGE } = CHALLENGE_DATA_TYPES;
var getAllTeams = (challengeId, errorContext) => __async(void 0, null, function* () {
  const response = yield leagueFetch16(
    `${TEAMS_PATH}?filter[challenge]=${challengeId}&include=${CHALLENGE}`,
    {
      errorContext: __spreadValues({ ownershipTeam: JOURNEY_EXPERIENCE_TEAM16 }, errorContext)
    }
  );
  if (!response.ok) {
    throw new Error(`getAllTeams error: ${response.status}`);
  }
  const responseJson = yield response.json();
  return deserialise10(responseJson);
});

// src/challenges/get-team-data-by-id.ts
import { leagueFetch as leagueFetch17 } from "@leagueplatform/league-fetch";
import { JOURNEY_EXPERIENCE_TEAM as JOURNEY_EXPERIENCE_TEAM17 } from "@leagueplatform/health-journey-common";
import { deserialise as deserialise11 } from "kitsu-core";
var { CHALLENGE: CHALLENGE2, USER, USER_CHALLENGE: USER_CHALLENGE2 } = CHALLENGE_DATA_TYPES;
var getTeamDataById = (teamId, errorContext) => __async(void 0, null, function* () {
  const response = yield leagueFetch17(
    `${TEAMS_PATH}/${teamId}?include=${CHALLENGE2},${USER},${USER_CHALLENGE2}`,
    {
      errorContext: __spreadValues({ ownershipTeam: JOURNEY_EXPERIENCE_TEAM17 }, errorContext)
    }
  );
  if (!response.ok) {
    throw new Error(`getTeamDataById error: ${response.status}`);
  }
  const responseJson = yield response.json();
  return deserialise11(responseJson);
});

// src/challenges/post-create-team.ts
import { leagueFetch as leagueFetch18 } from "@leagueplatform/league-fetch";
import { JOURNEY_EXPERIENCE_TEAM as JOURNEY_EXPERIENCE_TEAM18 } from "@leagueplatform/health-journey-common";
var postCreateTeam = (_0) => __async(void 0, [_0], function* ({
  challengeId,
  teamName,
  teamPhoto,
  errorContext
}) {
  const response = yield leagueFetch18(TEAMS_PATH, {
    method: "POST",
    body: JSON.stringify({
      data: {
        type: "challenge-team" /* CHALLENGE_TEAM */,
        attributes: {
          name: teamName,
          avatarUrl: teamPhoto
        },
        relationships: {
          challenge: {
            data: {
              id: challengeId,
              type: "challenge" /* CHALLENGE */
            }
          }
        }
      }
    }),
    errorContext: __spreadValues({ ownershipTeam: JOURNEY_EXPERIENCE_TEAM18 }, errorContext)
  });
  if (response.ok) {
    return response.json();
  }
  throw new Error("Something went wrong while posting!");
});

// src/challenges/get-team-challenge-ranks.ts
import { deserialise as deserialise12 } from "kitsu-core";
import { JOURNEY_EXPERIENCE_TEAM as JOURNEY_EXPERIENCE_TEAM19 } from "@leagueplatform/health-journey-common";
import { leagueFetch as leagueFetch19 } from "@leagueplatform/league-fetch";
var getTeamChallengeRanks = (challengeId, teamId, errorContext) => __async(void 0, null, function* () {
  const baseFetchPath = `${TEAM_CHALLENGE_RANKS_PATH}${challengeId}&page[size]=10&include=challenge-team`;
  const fetchTeamRanksPath = (teamId == null ? void 0 : teamId.length) ? `${baseFetchPath}&filter[team]=${teamId}` : baseFetchPath;
  const response = yield leagueFetch19(fetchTeamRanksPath, {
    errorContext: __spreadValues({ ownershipTeam: JOURNEY_EXPERIENCE_TEAM19 }, errorContext)
  });
  if (!response.ok) {
    throw new Error(`getTeamChallengeRanks error: ${response.status}`);
  }
  const responseJson = yield response.json();
  return deserialise12(responseJson);
});

// src/health-programs/constants/user-health-campaign.constants.ts
var USER_HEALTH_CAMPAIGNS_PATH = "/v1/user-health-campaigns";
var USER_HEALTH_CAMPAIGN_STATUS = /* @__PURE__ */ ((USER_HEALTH_CAMPAIGN_STATUS2) => {
  USER_HEALTH_CAMPAIGN_STATUS2["ACTIVE"] = "active";
  USER_HEALTH_CAMPAIGN_STATUS2["ENDED"] = "ended";
  USER_HEALTH_CAMPAIGN_STATUS2["COMPLETED"] = "completed";
  USER_HEALTH_CAMPAIGN_STATUS2["SUSPENDED"] = "suspended";
  return USER_HEALTH_CAMPAIGN_STATUS2;
})(USER_HEALTH_CAMPAIGN_STATUS || {});
var GET_USER_HEALTH_CAMPAIGN_MESSAGE_TYPE = "get_user_health_campaign";

// src/health-programs/get-health-goal-programs.ts
import { SocketAsFetch as SocketAsFetch8 } from "@leagueplatform/socket-as-fetch";
import { JOURNEY_EXPERIENCE_TEAM as JOURNEY_EXPERIENCE_TEAM20 } from "@leagueplatform/health-journey-common";
var GET_HEALTH_GOAL_PROGRAMS_MESSAGE_TYPE = "get_health_goal_programs";
var getHealthGoalPrograms = (errorContext) => __async(void 0, null, function* () {
  return SocketAsFetch8.fetch(
    {
      message_type: GET_HEALTH_GOAL_PROGRAMS_MESSAGE_TYPE,
      info: {
        version: 1
      }
    },
    {
      errorContext: __spreadValues({ ownershipTeam: JOURNEY_EXPERIENCE_TEAM20 }, errorContext)
    }
  );
});

// src/health-programs/get-health-goal-programs-by-category.ts
import { SocketAsFetch as SocketAsFetch9 } from "@leagueplatform/socket-as-fetch";
import { JOURNEY_EXPERIENCE_TEAM as JOURNEY_EXPERIENCE_TEAM21 } from "@leagueplatform/health-journey-common";
var getHealthGoalProgramsByCategory = (categoryId, errorContext) => __async(void 0, null, function* () {
  return SocketAsFetch9.fetch(
    {
      message_type: GET_HEALTH_GOAL_PROGRAMS_MESSAGE_TYPE,
      info: {
        category_id: categoryId,
        version: 1
      }
    },
    {
      errorContext: __spreadValues({ ownershipTeam: JOURNEY_EXPERIENCE_TEAM21 }, errorContext)
    }
  );
});

// src/health-programs/get-health-program-categories.ts
import { SocketAsFetch as SocketAsFetch10 } from "@leagueplatform/socket-as-fetch";
import { JOURNEY_EXPERIENCE_TEAM as JOURNEY_EXPERIENCE_TEAM22 } from "@leagueplatform/health-journey-common";
var GET_HEALTH_PROGRAM_CATEGORIES_MESSAGE_TYPE = "get_health_program_categories";
var getHealthProgramCategories = (errorContext) => __async(void 0, null, function* () {
  return SocketAsFetch10.fetch(
    {
      message_type: GET_HEALTH_PROGRAM_CATEGORIES_MESSAGE_TYPE
    },
    {
      errorContext: __spreadValues({ ownershipTeam: JOURNEY_EXPERIENCE_TEAM22 }, errorContext)
    }
  );
});

// src/health-programs/get-health-program-curated-carousels.ts
import { SocketAsFetch as SocketAsFetch11 } from "@leagueplatform/socket-as-fetch";
import { JOURNEY_EXPERIENCE_TEAM as JOURNEY_EXPERIENCE_TEAM23 } from "@leagueplatform/health-journey-common";
var GET_HEALTH_PROGRAM_CURATED_CAROUSELS_MESSAGE_TYPE = "get_health_program_curated_carousels";
var getHealthProgramCuratedCarousels = (type, errorContext) => __async(void 0, null, function* () {
  return SocketAsFetch11.fetch(
    {
      message_type: GET_HEALTH_PROGRAM_CURATED_CAROUSELS_MESSAGE_TYPE,
      info: { type }
    },
    {
      errorContext: __spreadValues({ ownershipTeam: JOURNEY_EXPERIENCE_TEAM23 }, errorContext)
    }
  );
});

// src/health-programs/get-health-program-suggested-carousels.ts
import { SocketAsFetch as SocketAsFetch12 } from "@leagueplatform/socket-as-fetch";
import { JOURNEY_EXPERIENCE_TEAM as JOURNEY_EXPERIENCE_TEAM24 } from "@leagueplatform/health-journey-common";
var GET_HEALTH_PROGRAM_SUGGESTED_CAROUSELS_MESSAGE_TYPE = "get_health_program_suggested_carousels";
var getHealthProgramSuggestedCarousels = (errorContext) => __async(void 0, null, function* () {
  return SocketAsFetch12.fetch(
    {
      message_type: GET_HEALTH_PROGRAM_SUGGESTED_CAROUSELS_MESSAGE_TYPE
    },
    {
      errorContext: __spreadValues({ ownershipTeam: JOURNEY_EXPERIENCE_TEAM24 }, errorContext)
    }
  );
});

// src/health-programs/get-user-health-campaign-by-id.ts
import { deserialise as deserialise13 } from "kitsu-core";
import { leagueFetch as leagueFetch20 } from "@leagueplatform/league-fetch";
var getUserHealthCampaignById = (userHealthCampaignId, includeUserHealthActivities, includeUserHealthCampaigns) => __async(void 0, null, function* () {
  let request = `${USER_HEALTH_CAMPAIGNS_PATH}/${userHealthCampaignId}`;
  const includedParams = [];
  if (includeUserHealthActivities) {
    includedParams.push("user-health-activity" /* USER_HEALTH_ACTIVITY */);
  }
  if (includeUserHealthCampaigns) {
    includedParams.push("user-health-campaign" /* USER_HEALTH_CAMPAIGN */);
  }
  if (includedParams.length > 0) {
    request = request.concat(`?included=${includedParams.toString()}`);
  }
  const response = yield leagueFetch20(request);
  if (response.ok) {
    return deserialise13(yield response.json());
  }
  throw new Error("Something went wrong while fetching!");
});

// src/health-programs/get-user-health-goal-programs.ts
import { SocketAsFetch as SocketAsFetch13 } from "@leagueplatform/socket-as-fetch";
import { JOURNEY_EXPERIENCE_TEAM as JOURNEY_EXPERIENCE_TEAM25 } from "@leagueplatform/health-journey-common";
var GET_USER_HEALTH_GOAL_PROGRAMS_MESSAGE_TYPE = "get_user_health_goal_programs";
var getUserHealthGoalPrograms = (errorContext) => __async(void 0, null, function* () {
  return SocketAsFetch13.fetch(
    {
      message_type: GET_USER_HEALTH_GOAL_PROGRAMS_MESSAGE_TYPE,
      info: {
        version: 1
      }
    },
    {
      errorContext: __spreadValues({ ownershipTeam: JOURNEY_EXPERIENCE_TEAM25 }, errorContext)
    }
  );
});

// src/health-programs/get-health-goal-program.ts
import { SocketAsFetch as SocketAsFetch14 } from "@leagueplatform/socket-as-fetch";
import { JOURNEY_EXPERIENCE_TEAM as JOURNEY_EXPERIENCE_TEAM26 } from "@leagueplatform/health-journey-common";
var GET_HEALTH_GOAL_PROGRAM_MESSAGE_TYPE = "get_health_goal_program";
var getHealthGoalProgram = (programId, errorContext, userProgramId, userId) => __async(void 0, null, function* () {
  return SocketAsFetch14.fetch(
    {
      message_type: GET_HEALTH_GOAL_PROGRAM_MESSAGE_TYPE,
      info: {
        program_id: programId,
        user_program_id: userProgramId,
        user_id: userId,
        version: 1
      }
    },
    {
      errorContext: __spreadValues({ ownershipTeam: JOURNEY_EXPERIENCE_TEAM26 }, errorContext)
    }
  );
});

// src/health-programs/start-health-goal-program.ts
import { SocketAsFetch as SocketAsFetch15 } from "@leagueplatform/socket-as-fetch";
import { JOURNEY_EXPERIENCE_TEAM as JOURNEY_EXPERIENCE_TEAM27 } from "@leagueplatform/health-journey-common";
var START_HEALTH_GOAL_PROGRAM_MESSAGE_TYPE = "start_health_goal_program";
var startHealthGoalProgram = (programId, isUserDeviceConnectableProgram, campaignMode, errorContext) => __async(void 0, null, function* () {
  return SocketAsFetch15.fetch(
    {
      message_type: START_HEALTH_GOAL_PROGRAM_MESSAGE_TYPE,
      info: __spreadValues({
        version: 2,
        program_id: programId
      }, isUserDeviceConnectableProgram && {
        campaign_custom_fields: {
          campaign_mode: campaignMode
        }
      })
    },
    {
      errorContext: __spreadValues({ ownershipTeam: JOURNEY_EXPERIENCE_TEAM27 }, errorContext)
    }
  );
});

// src/health-programs/quit-health-goal-program.ts
import { SocketAsFetch as SocketAsFetch16 } from "@leagueplatform/socket-as-fetch";
import { JOURNEY_EXPERIENCE_TEAM as JOURNEY_EXPERIENCE_TEAM28 } from "@leagueplatform/health-journey-common";
var QUIT_HEALTH_GOAL_PROGRAM_MESSAGE_TYPE = "quit_health_goal_program";
var quitHealthGoalProgram = (userProgramId, errorContext) => __async(void 0, null, function* () {
  return SocketAsFetch16.fetch(
    {
      message_type: QUIT_HEALTH_GOAL_PROGRAM_MESSAGE_TYPE,
      info: {
        user_program_id: userProgramId,
        version: 1
      }
    },
    {
      errorContext: __spreadValues({ ownershipTeam: JOURNEY_EXPERIENCE_TEAM28 }, errorContext)
    }
  );
});

// src/health-programs/get_suggested_user_activity_groups.ts
import { SocketAsFetch as SocketAsFetch17 } from "@leagueplatform/socket-as-fetch";
import { JOURNEY_EXPERIENCE_TEAM as JOURNEY_EXPERIENCE_TEAM29 } from "@leagueplatform/health-journey-common";
var GET_SUGGESTED_ACTIVITY_GROUPS = "get_suggested_user_health_activity_groups";
var getSuggestedUserActivityGroups = (errorContext) => __async(void 0, null, function* () {
  return SocketAsFetch17.fetch(
    {
      message_type: GET_SUGGESTED_ACTIVITY_GROUPS
    },
    {
      errorContext: __spreadValues({ ownershipTeam: JOURNEY_EXPERIENCE_TEAM29 }, errorContext)
    }
  );
});

// src/health-programs/get_suggested_user_health_activities.ts
import { SocketAsFetch as SocketAsFetch18 } from "@leagueplatform/socket-as-fetch";
import { JOURNEY_EXPERIENCE_TEAM as JOURNEY_EXPERIENCE_TEAM30 } from "@leagueplatform/health-journey-common";
var GET_SUGGESTED_ACTIVITIES = "get_suggested_user_health_activities";
var getSuggestedUserActivities = (groupId, errorContext) => __async(void 0, null, function* () {
  return SocketAsFetch18.fetch(
    {
      message_type: GET_SUGGESTED_ACTIVITIES,
      info: {
        suggested_activity_group_id: groupId
      }
    },
    {
      errorContext: __spreadValues({ ownershipTeam: JOURNEY_EXPERIENCE_TEAM30 }, errorContext)
    }
  );
});

// src/health-programs/get-active-campaign-limit-info.ts
import { SocketAsFetch as SocketAsFetch19 } from "@leagueplatform/socket-as-fetch";
import { JOURNEY_EXPERIENCE_TEAM as JOURNEY_EXPERIENCE_TEAM31 } from "@leagueplatform/health-journey-common";
var GET_ACTIVE_CAMPAIGN_LIMIT_INFO_MESSAGE_TYPE = "get_active_opt_in_campaign_limit_info";
var getActiveCampaignLimitInfo = (errorContext) => __async(void 0, null, function* () {
  return SocketAsFetch19.fetch(
    {
      message_type: GET_ACTIVE_CAMPAIGN_LIMIT_INFO_MESSAGE_TYPE
    },
    {
      errorContext: __spreadValues({ ownershipTeam: JOURNEY_EXPERIENCE_TEAM31 }, errorContext)
    }
  );
});

// src/health-programs/constants/user-health-goal-program.constants.ts
var USER_HEALTH_GOAL_PROGRAM_STATUS = /* @__PURE__ */ ((USER_HEALTH_GOAL_PROGRAM_STATUS2) => {
  USER_HEALTH_GOAL_PROGRAM_STATUS2["ACTIVE"] = "active";
  USER_HEALTH_GOAL_PROGRAM_STATUS2["COMPLETED"] = "completed";
  USER_HEALTH_GOAL_PROGRAM_STATUS2["SKIPPED"] = "skipped";
  USER_HEALTH_GOAL_PROGRAM_STATUS2["EXPIRED"] = "expired";
  USER_HEALTH_GOAL_PROGRAM_STATUS2["QUIT"] = "quit";
  return USER_HEALTH_GOAL_PROGRAM_STATUS2;
})(USER_HEALTH_GOAL_PROGRAM_STATUS || {});

// src/wearables/get-validic-user.ts
import { SocketAsFetch as SocketAsFetch20 } from "@leagueplatform/socket-as-fetch";
var GET_VALIDIC_USER_MESSAGE_TYPE = "get_validic_user";
var getValidicUser = (errorContext) => __async(void 0, null, function* () {
  return SocketAsFetch20.fetch(
    {
      message_type: GET_VALIDIC_USER_MESSAGE_TYPE
    },
    { errorContext }
  );
});

// src/wearables/set-wearables-consent.ts
import { SocketAsFetch as SocketAsFetch21 } from "@leagueplatform/socket-as-fetch";
var SET_WEARABLES_CONSENT_MESSAGE_TYPE = "set_wearables_consent";
var setWearablesConsent = (errorContext) => __async(void 0, null, function* () {
  return SocketAsFetch21.fetch(
    {
      message_type: SET_WEARABLES_CONSENT_MESSAGE_TYPE
    },
    { errorContext }
  );
});

// src/wearables/utils/does-user-have-sufficient-wearable-permissions.ts
function doesUserHaveSufficientWearablePermissions(requiredPermissions, grantedPermissions) {
  const userHasSufficiantWearablePermissions = requiredPermissions.filter(
    (requiredPermission) => grantedPermissions.includes(requiredPermission)
  ).length === requiredPermissions.length;
  return userHasSufficiantWearablePermissions;
}

// src/wearables/utils/find-granted-wearable-permissions.ts
function findGrantedWearablePermissions(devices) {
  const grantedPermissions = Object.values(devices).reduce(
    (accum, devicePermissions) => {
      const grantedDevicePermissions = Object.entries(devicePermissions).filter(([, granted]) => granted).map(([permission]) => permission);
      return [...accum, ...grantedDevicePermissions];
    },
    []
  );
  const removedDuplicatedPermissions = [...new Set(grantedPermissions)];
  return removedDuplicatedPermissions;
}

// src/wearables/hooks/use-get-wearables-consent-for-data-points.hooks.ts
import { useQuery } from "react-query";

// src/wearables/get-wearables-consent-for-data-points.ts
import { SocketAsFetch as SocketAsFetch22 } from "@leagueplatform/socket-as-fetch";
import { JOURNEY_EXPERIENCE_TEAM as JOURNEY_EXPERIENCE_TEAM32 } from "@leagueplatform/health-journey-common";
var getWearablesConsentForDataPoints = (..._0) => __async(void 0, [..._0], function* (dataPoints = [], devices = [], errorContext) {
  return SocketAsFetch22.fetch(
    {
      message_type: "get_wearables_consent_for_data_points",
      info: {
        data_points: dataPoints,
        devices
      }
    },
    {
      errorContext: __spreadValues({ ownershipTeam: JOURNEY_EXPERIENCE_TEAM32 }, errorContext)
    }
  );
});

// src/wearables/hooks/use-get-wearables-consent-for-data-points.hooks.ts
var GET_WEARABLES_CONSENT_FOR_DATA_POINTS_MESSAGE_TYPE = "wearablesConsentForDataPointsData";
var useGetWearablesConsentForDataPoints = (dataPoints = [], devices = []) => useQuery(
  [GET_WEARABLES_CONSENT_FOR_DATA_POINTS_MESSAGE_TYPE, dataPoints, devices],
  () => getWearablesConsentForDataPoints(dataPoints, devices),
  { enabled: (dataPoints == null ? void 0 : dataPoints.length) > 0 }
);

// src/wearables/user-connected-device-campaign-modes.constants.ts
var USER_CONNECTED_DEVICE_CAMPAIGN_MODES = Object.freeze({
  AUTOMATIC: "automatic",
  MANUAL: "manual"
});
export {
  ACTIVITY_PROGRESS_PROPERTIES,
  AdditionalDateOptionUnit,
  BannerTypes,
  BiometricStatusType,
  CHALLENGES_PATH,
  CHALLENGE_DATA_TYPES,
  CHALLENGE_HIGHLIGHTS_PATH,
  CHALLENGE_HIGHLIGHT_EVENT_TYPES,
  CHALLENGE_HIGHLIGHT_FEED_TYPES,
  CHALLENGE_HIGHLIGHT_IMAGE_TYPES,
  CHALLENGE_HIGHLIGHT_REACTION_TYPES,
  CHALLENGE_PATCH_OPERATIONS,
  CHALLENGE_TYPES,
  COMPLETE_USER_HEALTH_ACTIVITY_MESSAGE_TYPE,
  DISMISS_USER_HEALTH_ACTIVITY_MESSAGE_TYPE,
  DateInputMethodType,
  DateTimeInputDisplay,
  FreeTextInputType,
  GET_ACTIVE_CAMPAIGN_LIMIT_INFO_MESSAGE_TYPE,
  GET_HEALTH_GOAL_PROGRAMS_MESSAGE_TYPE,
  GET_HEALTH_GOAL_PROGRAM_MESSAGE_TYPE,
  GET_HEALTH_PROGRAM_CATEGORIES_MESSAGE_TYPE,
  GET_HEALTH_PROGRAM_CURATED_CAROUSELS_MESSAGE_TYPE,
  GET_HEALTH_PROGRAM_SUGGESTED_CAROUSELS_MESSAGE_TYPE,
  GET_SUGGESTED_ACTIVITIES,
  GET_SUGGESTED_ACTIVITY_GROUPS,
  GET_USER_CAMPAIGNS_MESSAGE_TYPE,
  GET_USER_HEALTH_ACTIVITIES_MESSAGE_TYPE,
  GET_USER_HEALTH_ACTIVITY_MESSAGE_TYPE,
  GET_USER_HEALTH_CAMPAIGN_MESSAGE_TYPE,
  GET_USER_HEALTH_GOAL_PROGRAMS_MESSAGE_TYPE,
  GET_USER_STANDALONE_ACTIVITIES_MESSAGE_TYPE,
  GET_WEARABLES_CONSENT_FOR_DATA_POINTS_MESSAGE_TYPE,
  HeightUnits,
  LEADERBOARD_RANKING_UNIT,
  ProgressTrackingInputMethod,
  QUIT_HEALTH_GOAL_PROGRAM_MESSAGE_TYPE,
  SET_ACTIVITY_PROGRESS_MESSAGE_TYPE,
  START_HEALTH_GOAL_PROGRAM_MESSAGE_TYPE,
  StringInputMethodType,
  StyleBackgroundColorType,
  StyleBorderRadiusType,
  StyleHorizontalAlignmentType,
  USER_CONNECTED_DEVICE_CAMPAIGN_MODES,
  USER_HEALTH_CAMPAIGN_STATUS,
  USER_HEALTH_GOAL_PROGRAM_STATUS,
  WeightUnits,
  completeUserHealthActivity,
  deleteUserChallenge,
  dismissUserHealthActivity,
  doesUserHaveSufficientWearablePermissions,
  findGrantedWearablePermissions,
  getActiveCampaignLimitInfo,
  getAllChallenges,
  getAllTeams,
  getAvatars,
  getChallengeConfig,
  getChallengeDataById,
  getHealthGoalProgram,
  getHealthGoalPrograms,
  getHealthGoalProgramsByCategory,
  getHealthProgramCategories,
  getHealthProgramCuratedCarousels,
  getHealthProgramSuggestedCarousels,
  getHighlightsFeedById,
  getIndividualUserRank,
  getSuggestedUserActivities,
  getSuggestedUserActivityGroups,
  getTeamChallengeRanks,
  getTeamDataById,
  getUserCampaigns,
  getUserChallengeRanks,
  getUserHealthActivities,
  getUserHealthActivity,
  getUserHealthActivityById,
  getUserHealthCampaignById,
  getUserHealthGoalPrograms,
  getUserHealthJourneyHistory,
  getUserHealthJourneyHistoryByPaginationLink,
  getUserStandaloneActivities,
  getValidicUser,
  patchChallengeTeam,
  patchChallengesPrivacySetting,
  patchHighlightReaction,
  postCreateTeam,
  postToolboxInteractionHub,
  postUserChallenge,
  quitHealthGoalProgram,
  setActivityProgress,
  setWearablesConsent,
  startHealthGoalProgram,
  useGetWearablesConsentForDataPoints
};
//# sourceMappingURL=index.js.map